<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">

      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>
      
      <div id="relatorio" class="card">
        <div class="card-title">
          <strong></strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h3>Relatório de Análise de Trabalho Sintético</h3>
            </div>
            <div class="col-md-6 text-right">
              <download-excel
                class   = "btn btn-default"
                :fields = "{'Data': 'data', 'Parado': 'tempoParadoTotal',  'Deslocamento': 'tempoDeslocamentoTotal',
                'Distância': 'kmRodadosTotal', 'Distância Odômetro': 'kmRodadosTotalOdometro', 'Velocidade Máxima': 'velocidadeMaximaTotal', 'Velocidade Média': 'velocidadeMediaTotal' }"
                :data   = "dadosRelatorios.dados"
                :title = "'Data: '+dadosRelatorios.data + '\n  Veículo: ' + dadosRelatorios.veiculo +  '\n  Empresa: ' + dadosRelatorios.empresa + '\n\n' + '  Parado : ' + dadosRelatorios.tempoParadoTotal  + '  Deslocamento : ' + dadosRelatorios.tempoDeslocamentoTotal + '  Distância Percorrida: ' + formatarVelocidade(dadosRelatorios.kmRodadosTotal) + 'Km' + '\n  Distância Percorrida GPS: ' + formatarVelocidade(dadosRelatorios.kmRodadosTotalOdometro) + ' Km ' + '\n  Velocidade Média: ' + formatarVelocidade(dadosRelatorios.velocidadeMediaTotal) + ' Km/h ' + '\n  Velocidade Máxima: ' + formatarVelocidade(dadosRelatorios.velocidadeMaximaTotal) + ' Km/h ' "
                worksheet = "My Worksheet"
                name    = "filename.xls">
                <button class="btn btn-success">Download XLS</button>
              </download-excel>
              
              <router-link id="btnNovoVeiculo" class="btn btn-danger" to="/relatorios">
                <span class="glyphicon glyphicon-plus"></span> Fechar
              </router-link>
            </div>
          </div>
          <div class="row" style="margin-top: 12px; margin-bottom: 12px;">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4"> 
                  <strong>Data: </strong>{{dadosRelatorios.data}}
                </div>
                <div class="col-md-3">
                  <strong>Veículo: </strong> {{dadosRelatorios.veiculo}}
                </div>
                <div class="col-md-5">
                  <strong>Empresa: </strong>{{dadosRelatorios.empresa}} 
                </div>
              </div>
            </div>
          </div>

          <template v-if="processando === false">
            <template v-if="dadosRelatorios.dados.length > 0">
              <table class="table table-responsive-sm table-hover table-outline mb-0">
                <thead class="thead-light">
                  <tr>
                    <th width="100">DATA</th>
                    <th width="180">PARADO</th>
                    <th width="180">DESLOCAMENTO</th>
                    <th >DISTANCIA</th>
                    <th width="130">VEL MAX</th>
                    <th width="130">VEL MEDIA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(dados, i) in dadosRelatorios.dados" @click="selecionarItem(dados)">
                    <td>
                      <input :id="'latitude_'+i" type="hidden" v-model="dados.latitude" />
                      <input :id="'longitude_'+i" type="hidden" v-model="dados.longitude" />
                      <small class="text-muted">{{dados.data}}</small></td>
                    <td><small class="text-muted">{{dados.tempoParadoTotal}}</small></td>
                    <td><small class="text-muted">{{dados.tempoDeslocamentoTotal}}</small></td>
                    <td><small class="text-muted">{{formatarVelocidade(dados.kmRodadosTotal)}} / {{formatarVelocidade(dados.kmRodadosTotalOdometro)}} Km</small></td>
                    <td><small class="text-muted">{{formatarVelocidade(dados.velocidadeMaximaTotal)}} Km/h</small></td>
                    <td><small class="text-muted">{{formatarVelocidade(dados.velocidadeMediaTotal)}} Km/h</small></td>
                  </tr>
                </tbody>
              </table>
              <div class="pull-right">
                <strong>Parado:</strong> {{dadosRelatorios.tempoParadoTotal}} <br>
                <strong>Deslocamento:</strong> {{dadosRelatorios.tempoDeslocamentoTotal}} <br>
                <strong>Distância Percorrida:</strong> {{formatarVelocidade(dadosRelatorios.kmRodadosTotal)}} Km <br>
                <strong>Velocidade Média:</strong> {{formatarVelocidade(dadosRelatorios.velocidadeMediaTotal)}} Km/h <br>
                <strong>Velocidade Máxima:</strong> {{formatarVelocidade(dadosRelatorios.velocidadeMaximaTotal)}} Km/h <br>
              </div>
            </template>          
            <template v-else>
              <div id="relatorio-sem-dados">
                <h1><bold>Sem dados para o período</bold></h1>
              </div>
            </template>
          </template>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    }
  },
  mounted () {
    this.buscarRelatorio()
  },
  methods: {
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
    },
    selecionado: function (item) {
      return this.selecionada === item.idVeiculo
    },
    buscarRelatorio: function () {
      var self = this
      self.processando = true
      var veiculoId = this.$route.params.veiculoId
      var dataHoraInicial = this.$route.params.dataHoraInicial
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataHoraFinal
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/')
      var filtroVelocidade = this.$route.params.filtroVelocidade
      var desprezarVelocidade = this.$route.params.desprezarVelocidade
      var entrada = this.$route.params.entrada
      var entradaVelocidade = this.$route.params.entradaVelocidade
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/relatorios/relatorioDeAnaliseTrabalhoProducaoSintetico?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&entrada=' + entrada + '&entradaVelocidade=' + entradaVelocidade
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosRelatorios = dadosCadastro
        self.processando = false
      })
    }
  }
}
</script>
}
</script>




// WEBPACK FOOTER //
// src/components/views/relatorios/RelatorioDeAnaliseTrabalhoProducaoSinteticoView.vue